// @flow
import { DISMISS_ALERT, DISMISS_ALL_ALERTS, REQUEST_ALERT } from './constants';

import { alerts } from '~/core/constants';
import { createAction } from 'redux-actions';
import type { Payload } from './types';
export const dismissAlert = createAction(DISMISS_ALERT);
export const dismissAllAlerts = createAction(DISMISS_ALL_ALERTS);

let nextAlertId = 0;

export const requestAlert = createAction(
    REQUEST_ALERT,
    (
        text: $npm$ReactIntl$MessageDescriptor,
        type: string = alerts.types.INFO,
        isPersistent: boolean = false,
        {
            intlValues,
            expiryMs
        }: {
            intlValues: { [key: string]: string },
            expiryMs?: number
        } = {}
    ) => {
        const payload: Payload = {
            id: nextAlertId++,
            isPersistent,
            text,
            type,
            intlValues,
            expiryMs
        };
        return payload;
    }
);



// WEBPACK FOOTER //
// ./src/core/state/alerts/actions.js